import { Notification, NotificationRecipient } from '../types';

export const mockNotifications: Notification[] = [
  {
    id: '1',
    title: 'Welcome to the New School Year',
    content: 'We are excited to welcome all students and families to the 2024-2025 school year. Please review your fee assessments and complete any outstanding payments.',
    notificationType: 'both',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-08-15T09:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-08-14T15:30:00'),
    updatedAt: new Date('2024-08-14T15:30:00'),
  },
  {
    id: '2',
    title: 'Early Bird Registration Discount',
    content: 'Register for fall courses by September 1st and receive a 10% discount on course materials. Visit the Fee Catalog to browse available courses.',
    notificationType: 'system',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents', 'community'],
    status: 'sent',
    sentAt: new Date('2024-08-20T10:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-08-19T14:00:00'),
    updatedAt: new Date('2024-08-19T14:00:00'),
  },
  {
    id: '3',
    title: 'Upcoming School Events',
    content: 'Join us for Back to School Night on September 10th at 6:00 PM. This is a great opportunity to meet teachers and learn about the curriculum.',
    notificationType: 'email',
    deliveryType: 'automated',
    targetAudience: ['parents'],
    status: 'scheduled',
    scheduledAt: new Date('2024-09-05T08:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-08-25T11:00:00'),
    updatedAt: new Date('2024-08-25T11:00:00'),
  },
  {
    id: '4',
    title: 'Payment Reminder',
    content: 'This is a friendly reminder that course material fees are due by September 15th. Please complete your payment to avoid any late fees.',
    notificationType: 'both',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'draft',
    createdBy: 'admin-1',
    createdAt: new Date('2024-08-26T09:30:00'),
    updatedAt: new Date('2024-08-26T09:30:00'),
  },
  {
    id: '5',
    title: 'Field Trip Permission Required',
    content: 'The Science Department is planning a field trip to the Natural History Museum on October 5th. Permission slips and payment are due by September 28th. Cost is $25 per student.',
    notificationType: 'both',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-09-10T08:30:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-09-09T14:00:00'),
    updatedAt: new Date('2024-09-09T14:00:00'),
  },
  {
    id: '6',
    title: 'Bus Pass Now Available',
    content: 'Your monthly bus pass is now ready for download. Visit the Purchases page to access your digital pass and add it to your mobile wallet.',
    notificationType: 'system',
    deliveryType: 'manual',
    targetAudience: ['students'],
    status: 'sent',
    sentAt: new Date('2024-09-01T07:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-08-31T16:00:00'),
    updatedAt: new Date('2024-08-31T16:00:00'),
  },
  {
    id: '7',
    title: 'Parent-Teacher Conference Sign-Up',
    content: 'Parent-Teacher conferences will be held October 15-17. Please sign up for your preferred time slot through the parent portal. Slots are filling up quickly!',
    notificationType: 'email',
    deliveryType: 'manual',
    targetAudience: ['parents'],
    status: 'sent',
    sentAt: new Date('2024-09-25T09:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-09-24T11:00:00'),
    updatedAt: new Date('2024-09-24T11:00:00'),
  },
  {
    id: '8',
    title: 'School Closure - Weather',
    content: 'Due to inclement weather conditions, school will be closed tomorrow, January 8th. All after-school activities and sports practices are also cancelled. Stay safe!',
    notificationType: 'both',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2026-01-07T18:30:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2026-01-07T18:00:00'),
    updatedAt: new Date('2026-01-07T18:00:00'),
  },
  {
    id: '9',
    title: 'Fall Drama Production Tickets',
    content: 'Tickets are now on sale for our fall production of "The Wizard of Oz". Shows are November 8-10 at 7:00 PM. Purchase tickets through the Fee Catalog.',
    notificationType: 'system',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents', 'community'],
    status: 'sent',
    sentAt: new Date('2024-10-15T10:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-10-14T15:00:00'),
    updatedAt: new Date('2024-10-14T15:00:00'),
  },
  {
    id: '10',
    title: 'Yearbook Pre-Order Deadline',
    content: 'Pre-order your 2024-2025 yearbook by October 31st to lock in the early bird price of $45. After this date, the price increases to $60.',
    notificationType: 'both',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-10-01T09:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-09-30T14:30:00'),
    updatedAt: new Date('2024-09-30T14:30:00'),
  },
  {
    id: '11',
    title: 'Homecoming Week Activities',
    content: 'Homecoming week is October 21-25! Check the events calendar for daily themes, the pep rally schedule, and the homecoming dance details. Tickets for the dance are $15.',
    notificationType: 'system',
    deliveryType: 'manual',
    targetAudience: ['students'],
    status: 'sent',
    sentAt: new Date('2024-10-08T08:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-10-07T13:00:00'),
    updatedAt: new Date('2024-10-07T13:00:00'),
  },
  {
    id: '12',
    title: 'Volunteer Opportunity - Book Fair',
    content: 'We need parent volunteers for our annual book fair, November 12-15. Each shift is 2 hours. Sign up through the volunteer coordinator or reply to this notification.',
    notificationType: 'email',
    deliveryType: 'manual',
    targetAudience: ['parents'],
    status: 'sent',
    sentAt: new Date('2024-10-20T10:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-10-19T15:00:00'),
    updatedAt: new Date('2024-10-19T15:00:00'),
  },
  {
    id: '13',
    title: 'Grade Report Available',
    content: 'First quarter grade reports are now available in the student portal. Please review with your student and contact teachers if you have any questions.',
    notificationType: 'both',
    deliveryType: 'automated',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-10-25T16:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-10-24T14:00:00'),
    updatedAt: new Date('2024-10-24T14:00:00'),
  },
  {
    id: '14',
    title: 'Winter Sports Registration Open',
    content: 'Registration for winter sports (basketball, wrestling, swimming) is now open. Sign up by November 1st. Physical exams must be current.',
    notificationType: 'system',
    deliveryType: 'manual',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-10-18T09:00:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-10-17T12:00:00'),
    updatedAt: new Date('2024-10-17T12:00:00'),
  },
  {
    id: '15',
    title: 'Payment Confirmation - Lab Fee',
    content: 'Thank you for your payment of $35.00 for the Chemistry Lab Fee. Your receipt has been generated and is available in the Purchases section.',
    notificationType: 'both',
    deliveryType: 'automated',
    targetAudience: ['students', 'parents'],
    status: 'sent',
    sentAt: new Date('2024-09-12T14:23:00'),
    createdBy: 'admin-1',
    createdAt: new Date('2024-09-12T14:23:00'),
    updatedAt: new Date('2024-09-12T14:23:00'),
  },
];

export const mockNotificationRecipients: NotificationRecipient[] = [
  {
    id: 'r1',
    notificationId: '1',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2024-08-15T10:30:00'),
    emailSentAt: new Date('2024-08-15T09:00:00'),
    emailDeliveredAt: new Date('2024-08-15T09:01:00'),
    createdAt: new Date('2024-08-15T09:00:00'),
  },
  {
    id: 'r2',
    notificationId: '1',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    email: 'michael.johnson@email.com',
    readAt: new Date('2024-08-15T11:00:00'),
    emailSentAt: new Date('2024-08-15T09:00:00'),
    emailDeliveredAt: new Date('2024-08-15T09:01:00'),
    createdAt: new Date('2024-08-15T09:00:00'),
  },
  {
    id: 'r3',
    notificationId: '1',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    email: 'liam.smith@school.edu',
    readAt: new Date('2024-08-15T12:15:00'),
    emailSentAt: new Date('2024-08-15T09:00:00'),
    emailDeliveredAt: new Date('2024-08-15T09:01:00'),
    createdAt: new Date('2024-08-15T09:00:00'),
  },
  {
    id: 'r4',
    notificationId: '1',
    userId: '650e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    email: 'sarah.smith@email.com',
    emailSentAt: new Date('2024-08-15T09:00:00'),
    emailDeliveredAt: new Date('2024-08-15T09:01:00'),
    createdAt: new Date('2024-08-15T09:00:00'),
  },
  {
    id: 'r5',
    notificationId: '2',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2024-08-20T14:00:00'),
    createdAt: new Date('2024-08-20T10:00:00'),
  },
  {
    id: 'r6',
    notificationId: '2',
    userId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'student',
    email: 'olivia.williams@school.edu',
    createdAt: new Date('2024-08-20T10:00:00'),
  },
  {
    id: 'r7',
    notificationId: '3',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    email: 'michael.johnson@email.com',
    createdAt: new Date('2024-09-05T08:00:00'),
  },
  {
    id: 'r8',
    notificationId: '3',
    userId: '650e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    email: 'sarah.smith@email.com',
    createdAt: new Date('2024-09-05T08:00:00'),
  },
  {
    id: 'r9',
    notificationId: '5',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2024-09-10T09:15:00'),
    emailSentAt: new Date('2024-09-10T08:30:00'),
    emailDeliveredAt: new Date('2024-09-10T08:31:00'),
    createdAt: new Date('2024-09-10T08:30:00'),
  },
  {
    id: 'r10',
    notificationId: '5',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    email: 'michael.johnson@email.com',
    readAt: new Date('2024-09-10T18:30:00'),
    emailSentAt: new Date('2024-09-10T08:30:00'),
    emailDeliveredAt: new Date('2024-09-10T08:31:00'),
    createdAt: new Date('2024-09-10T08:30:00'),
  },
  {
    id: 'r11',
    notificationId: '6',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    email: 'liam.smith@school.edu',
    readAt: new Date('2024-09-01T07:45:00'),
    createdAt: new Date('2024-09-01T07:00:00'),
  },
  {
    id: 'r12',
    notificationId: '6',
    userId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'student',
    email: 'noah.brown@school.edu',
    readAt: new Date('2024-09-01T08:20:00'),
    createdAt: new Date('2024-09-01T07:00:00'),
  },
  {
    id: 'r13',
    notificationId: '7',
    userId: '650e8400-e29b-41d4-a716-446655440003',
    userType: 'parent',
    email: 'david.williams@email.com',
    readAt: new Date('2024-09-25T20:15:00'),
    emailSentAt: new Date('2024-09-25T09:00:00'),
    emailDeliveredAt: new Date('2024-09-25T09:01:00'),
    createdAt: new Date('2024-09-25T09:00:00'),
  },
  {
    id: 'r14',
    notificationId: '7',
    userId: '650e8400-e29b-41d4-a716-446655440004',
    userType: 'parent',
    email: 'jennifer.brown@email.com',
    emailSentAt: new Date('2024-09-25T09:00:00'),
    emailDeliveredAt: new Date('2024-09-25T09:01:00'),
    createdAt: new Date('2024-09-25T09:00:00'),
  },
  {
    id: 'r15',
    notificationId: '8',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2026-01-07T18:45:00'),
    emailSentAt: new Date('2026-01-07T18:30:00'),
    emailDeliveredAt: new Date('2026-01-07T18:31:00'),
    createdAt: new Date('2026-01-07T18:30:00'),
  },
  {
    id: 'r16',
    notificationId: '8',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    email: 'michael.johnson@email.com',
    readAt: new Date('2026-01-07T18:35:00'),
    emailSentAt: new Date('2026-01-07T18:30:00'),
    emailDeliveredAt: new Date('2026-01-07T18:31:00'),
    createdAt: new Date('2026-01-07T18:30:00'),
  },
  {
    id: 'r17',
    notificationId: '8',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    email: 'liam.smith@school.edu',
    readAt: new Date('2026-01-07T19:00:00'),
    emailSentAt: new Date('2026-01-07T18:30:00'),
    emailDeliveredAt: new Date('2026-01-07T18:31:00'),
    createdAt: new Date('2026-01-07T18:30:00'),
  },
  {
    id: 'r18',
    notificationId: '9',
    userId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'student',
    email: 'olivia.williams@school.edu',
    readAt: new Date('2024-10-15T11:30:00'),
    createdAt: new Date('2024-10-15T10:00:00'),
  },
  {
    id: 'r19',
    notificationId: '9',
    userId: '650e8400-e29b-41d4-a716-446655440005',
    userType: 'parent',
    email: 'robert.davis@email.com',
    createdAt: new Date('2024-10-15T10:00:00'),
  },
  {
    id: 'r20',
    notificationId: '10',
    userId: '550e8400-e29b-41d4-a716-446655440004',
    userType: 'student',
    email: 'noah.brown@school.edu',
    readAt: new Date('2024-10-01T15:20:00'),
    emailSentAt: new Date('2024-10-01T09:00:00'),
    emailDeliveredAt: new Date('2024-10-01T09:01:00'),
    createdAt: new Date('2024-10-01T09:00:00'),
  },
  {
    id: 'r21',
    notificationId: '10',
    userId: '650e8400-e29b-41d4-a716-446655440004',
    userType: 'parent',
    email: 'jennifer.brown@email.com',
    readAt: new Date('2024-10-01T19:45:00'),
    emailSentAt: new Date('2024-10-01T09:00:00'),
    emailDeliveredAt: new Date('2024-10-01T09:01:00'),
    createdAt: new Date('2024-10-01T09:00:00'),
  },
  {
    id: 'r22',
    notificationId: '11',
    userId: '550e8400-e29b-41d4-a716-446655440005',
    userType: 'student',
    email: 'ava.davis@school.edu',
    readAt: new Date('2024-10-08T08:30:00'),
    createdAt: new Date('2024-10-08T08:00:00'),
  },
  {
    id: 'r23',
    notificationId: '11',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2024-10-08T09:15:00'),
    createdAt: new Date('2024-10-08T08:00:00'),
  },
  {
    id: 'r24',
    notificationId: '12',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    userType: 'parent',
    email: 'lisa.johnson@email.com',
    readAt: new Date('2024-10-20T11:45:00'),
    emailSentAt: new Date('2024-10-20T10:00:00'),
    emailDeliveredAt: new Date('2024-10-20T10:01:00'),
    createdAt: new Date('2024-10-20T10:00:00'),
  },
  {
    id: 'r25',
    notificationId: '12',
    userId: '650e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    email: 'sarah.smith@email.com',
    emailSentAt: new Date('2024-10-20T10:00:00'),
    emailDeliveredAt: new Date('2024-10-20T10:01:00'),
    createdAt: new Date('2024-10-20T10:00:00'),
  },
  {
    id: 'r26',
    notificationId: '13',
    userId: '550e8400-e29b-41d4-a716-446655440002',
    userType: 'student',
    email: 'liam.smith@school.edu',
    readAt: new Date('2024-10-25T17:30:00'),
    emailSentAt: new Date('2024-10-25T16:00:00'),
    emailDeliveredAt: new Date('2024-10-25T16:01:00'),
    createdAt: new Date('2024-10-25T16:00:00'),
  },
  {
    id: 'r27',
    notificationId: '13',
    userId: '650e8400-e29b-41d4-a716-446655440002',
    userType: 'parent',
    email: 'sarah.smith@email.com',
    readAt: new Date('2024-10-25T19:00:00'),
    emailSentAt: new Date('2024-10-25T16:00:00'),
    emailDeliveredAt: new Date('2024-10-25T16:01:00'),
    createdAt: new Date('2024-10-25T16:00:00'),
  },
  {
    id: 'r28',
    notificationId: '14',
    userId: '550e8400-e29b-41d4-a716-446655440003',
    userType: 'student',
    email: 'olivia.williams@school.edu',
    createdAt: new Date('2024-10-18T09:00:00'),
  },
  {
    id: 'r29',
    notificationId: '14',
    userId: '650e8400-e29b-41d4-a716-446655440003',
    userType: 'parent',
    email: 'david.williams@email.com',
    readAt: new Date('2024-10-18T20:15:00'),
    createdAt: new Date('2024-10-18T09:00:00'),
  },
  {
    id: 'r30',
    notificationId: '15',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    readAt: new Date('2024-09-12T14:30:00'),
    emailSentAt: new Date('2024-09-12T14:23:00'),
    emailDeliveredAt: new Date('2024-09-12T14:24:00'),
    createdAt: new Date('2024-09-12T14:23:00'),
  },
  {
    id: 'r31',
    notificationId: '15',
    userId: '650e8400-e29b-41d4-a716-446655440001',
    userType: 'parent',
    email: 'michael.johnson@email.com',
    readAt: new Date('2024-09-12T18:45:00'),
    emailSentAt: new Date('2024-09-12T14:23:00'),
    emailDeliveredAt: new Date('2024-09-12T14:24:00'),
    createdAt: new Date('2024-09-12T14:23:00'),
  },
  {
    id: 'r32',
    notificationId: '8',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    userType: 'parent',
    email: 'lisa.johnson@email.com',
    emailSentAt: new Date('2026-01-07T18:30:00'),
    emailDeliveredAt: new Date('2026-01-07T18:31:00'),
    createdAt: new Date('2026-01-07T18:30:00'),
  },
  {
    id: 'r33',
    notificationId: '10',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    emailSentAt: new Date('2024-10-01T09:00:00'),
    emailDeliveredAt: new Date('2024-10-01T09:01:00'),
    createdAt: new Date('2024-10-01T09:00:00'),
  },
  {
    id: 'r34',
    notificationId: '14',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    userType: 'student',
    email: 'emma.johnson@school.edu',
    createdAt: new Date('2024-10-18T09:00:00'),
  },
  {
    id: 'r35',
    notificationId: '9',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    userType: 'parent',
    email: 'lisa.johnson@email.com',
    createdAt: new Date('2024-10-15T10:00:00'),
  },
  {
    id: 'r36',
    notificationId: '13',
    userId: '650e8400-e29b-41d4-a716-446655440006',
    userType: 'parent',
    email: 'lisa.johnson@email.com',
    emailSentAt: new Date('2024-10-25T16:00:00'),
    emailDeliveredAt: new Date('2024-10-25T16:01:00'),
    createdAt: new Date('2024-10-25T16:00:00'),
  },
];
